import {Component, ViewEncapsulation} from "@angular/core";
import {SettingsService} from "../../../shared/settings.service";

@Component({
    selector: 'hc-compact-header',
    templateUrl: './hc-compact-header.component.html',
    styleUrls: ['./hc-compact-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {'id': 'hc-compact-header'},
})

export class HcCompactHeaderComponent {
    constructor(public settings: SettingsService) {}
}



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/app/help-center/front/hc-compact-header/hc-compact-header.component.ts